const fetchAiInspectionInfo = async (org_id, inspection_id) => {
    return fetch(`/dashboard/organizations/${org_id}/ai-inspections/${inspection_id}.json`)
        .then(r => r.json());
}
const fetchAiInspectionMessages = async (org_id, inspection_id, conversation_id, page, search) => {
    return fetch(`/dashboard/organizations/${org_id}/ai-inspections/${inspection_id}/ai-conversations/${conversation_id}/ai-messages.json?page=${page}&search=${search}`)
        .then(r => r.json());
}

const sendAiInspectionMessage = async (org_id, ai_inspection_id, conversation_id, messageData, files) => {
    const response = await fetch(
        `/dashboard/organizations/${org_id}/ai-inspections/${ai_inspection_id}/ai-conversations/${conversation_id}/ai-messages.json`,
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(messageData),
        })
        .then(r => r.json());

    return response;
}


const uploadShort = () => {
    // append a short video
    //
    const shortVideo = new File([new Blob(['<video width="320" height="240" controls><source src="movie.mp4" type="video/mp4"></video>'], {type: 'video/mp4'})], 'short_video.mp4', {type: 'video/mp4'});
    const formData = new FormData();
    formData.append('short_video', shortVideo);
    formData.append('image', selectedFile.value);
    fetch('/api/upload', {
        method: 'POST',
        body: formData,
    })
        .then(response => response.json())
}


function uploadPhoto() {
    if (!capturedImage.value) return

    // Example: Convert base64 data back into a raw file object for backend uploads
    fetch(capturedImage.value)
        .then(res => res.blob())
        .then(blob => {
            const file = new File([blob], 'snapshot.jpg', {type: 'image/jpeg'})
            // Send 'file' payload using your standard API service client here
            console.log('File ready for API form upload:', file)
        })
}

export {fetchAiInspectionInfo, sendAiInspectionMessage, fetchAiInspectionMessages}